// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"6cc4526b","203":"3d66341e","453":"9d9ceda2","520":"9f9beae6","598":"24cf02ea","672":"f668c9a1","700":"e79ec814","811":"a3f302e2","829":"4262040c","901":"48648b5e"}[chunkId] + ".chunk.js";
};